export * from './UIGameActionButtonKnightActivation.tsx';
